import React from 'react';
import Request from '../../model/Request';
import { useQuery } from '@tanstack/react-query';
import { setUrlToHTTPs } from '../../utils';
import { useAppendAuthorizationHeader } from '../../utils/connector/api-connector';
import { matchPath } from 'react-router';
import SimpleRequestView from '../../components/RequestView/SimpleRequestView';
import TestType from '../../model/TestType';
import MediaQuery from 'react-responsive';
import Spinner from '../../components/Spinner/Spinner';
import keycloak from '../../keycloak';

interface RequestViewControllerI {
    request: Request
}



const RequestViewController: React.FC<RequestViewControllerI> = (props) => {
    const {request} = props
 //   console.log('Request: ', request)
    const header = useAppendAuthorizationHeader()
    const testLink = request.links.testType?.href
    //const bookings = request.links.bookings?.href

    let component = (width: number, height: number, testType: TestType): React.ReactElement => {
        return (
            <SimpleRequestView
            height={height}
            width={width}
            request={request}
            test={testType}
            expanded={false}
        />
        )
    }

    const testL = new URL(testLink??'')
  //  const bookingL = bookings ? new URL(bookings) : new URL(window.location.href)
    const {realm} = keycloak
    const testMatchPath = matchPath({path: `${realm === 'registrar' ? '/v1/accreditation': ''}/testTypes/:type`, caseSensitive: false}, testL.pathname)
//    const bookingsMatchPath = matchPath({path: '/requests/:requestId/bookings'}, bookingL.pathname)
    //console.log('testLink: ', testLink, testL.pathname, testMatchPath, bookingsMatchPath, bookings)

    const testTypeData = useQuery<TestType>({
        enabled: testLink !== undefined,
        queryKey: ['testType',  `${testMatchPath?.params.type??0}`],
        queryFn: async () => {
            const data =
                await fetch(setUrlToHTTPs(`${testLink}`), {...header})
            return data.json()
        }}
    )
/*
    const bookingsData = useQuery({
        enabled: bookings !== undefined,
        queryKey: ['bookings', 'registry', 'request', `${bookingsMatchPath?.params.requestId??0}`],
        queryFn: async () => {
            const data =
                await fetch(setUrlToHTTPs(`${bookings}`), {...header})
            return data.json()
        }}
    )
*/
    if (testTypeData.isFetched) {
        const testType = testTypeData.data ?? {} as TestType
       // console.log('TestTypeData: ', testTypeData.data)
        return (
        <div>
            <MediaQuery minWidth={1700}>
                <div style={{marginBottom: '0.5vh', width: '46.5vw'}}>
                    {component(46, 15, testType)}
                </div>
            </MediaQuery>

            <MediaQuery minWidth={1150} maxWidth={1699}>
                <div style={{marginBottom: '0.5vh', width: '45vw'}}>
                    {component(45, 20, testType)}
                </div>
            </MediaQuery>

            <MediaQuery minWidth={1024} maxWidth={1149}>
                <div style={{marginBottom: '0.5vh', width: '42vw'}}>
                    {component(42, 30, testType)}
                </div>
            </MediaQuery>

            <MediaQuery minWidth={850} maxWidth={1023}>
                <div style={{marginBottom: '0.5vh', width: '85vw'}}>
                    {component(60, 30, testType)}
                </div>
            </MediaQuery>

            <MediaQuery minWidth={300} maxWidth={849}>
                <div style={{marginBottom: '0.5vh', width: '80vw'}}>
                    {component(60, 30, testType)}
                </div>
            </MediaQuery>
        </div>
        )
    }

    if (testTypeData.isError) {
        return (<span>Error</span>)
    }
    return (
        <Spinner/>
    )
}

export default RequestViewController